import React from 'react';
import PropTypes from 'prop-types';
import { mapCreatorConnect } from '../../higher-order-components';
import * as Api from 'api';
import DateTimeField from 'react-bootstrap-datetimepicker';
import moment from 'moment';
import {
  ButtonGroup,
  Button,
  ButtonToolbar,
  Col,
  Row
} from 'react-bootstrap';
import {
  MapSwathControls,
  MapsList,
  SwathEditor,
  MarkerCreator,
  MarkerEditor
 } from 'components';

class MapCreatorSidebar extends React.Component {
  constructor(props) {
    super(props);

    this.handleDeleteSwath = this.handleDeleteSwath.bind(this);
  }

  handleDeleteSwath(featureID, mapID) {
    this.props.sendSocketEmit({ mapID, featureID }, 'delete-map-feature');
  }

  render() {
    const {
      storm_date,
      current_map,
      drawing_mode,
      current_feature
    } = this.props.mapCreator;
    const show_swath_editor = (
      current_map != null &&
      current_feature != null &&
      current_feature.geometry.type == 'Polygon' &&
      (drawing_mode == 'Polygon' || drawing_mode == null)
    );
    const show_marker_editor = (
      current_map != null &&
      current_feature != null &&
      current_feature.geometry.type == 'Point'
    );
    const show_marker_creator = (
      current_feature == null &&
      drawing_mode == 'Point'
    );
    const parsed_storm_date = moment(storm_date).format('MM/DD/YYYY');

    return (
      <menu id='content-menu' className='inner-menu map-creator-sidebar-container' role='menu'>
        <div className='nano'>
          <div className='nano-content'>
            <div className='inner-menu-toggle-inside'>
              <a onClick={(e) => { $('html').removeClass('inner-menu-opened') }} className='inner-menu-collapse'>
                <i className='fa fa-chevron-up visible-xs-inline' /><i className='fa fa-chevron-left hidden-xs-inline' /> Hide Options
              </a>
              <a onClick={(e) => {
                $('html').addClass('inner-menu-opened')
              }} className='inner-menu-expand' data-open='inner-menu'>
                Show Options <i className='fa fa-chevron-down' />
              </a>
            </div>
            <div className='inner-menu-content'>
            <h3 className='title'>Maps</h3>
            {/* {(()=>{
              if(current_users.length > 0) {
                return <p>Now Editing:  {current_users.join(', ')}</p>
              }
            })()} */}
            <h4>Storm Date {parsed_storm_date}</h4>
            <DateTimeField
              className={'mb-lg'}
              onChange={new_date => this.props.updateMapStormDate(moment(new_date, 'MM/DD/YYYY').toDate())}
              dateTime={parsed_storm_date}
              format={'MM/DD/YYYY'}
              inputFormat={'MM/DD/YYYY'}
              showToday={true}
              viewMode='days'
            />
            <h4 className='title'>Opacity</h4>
            <div className="mt-lg">
              <h4>Swath Opacity</h4>
              <div
                className="mb-lg mt-lg slider-primary"
                data-plugin-slider
                data-plugin-options='{ "value": 30, "range": "min", "max": 100 }'
                data-plugin-slider-output="#listenSlider"
                >
                <input
                  id="listenSlider"
                  type="hidden"
                  value="30"
                />
              </div>
              <p className="slider-output">The current opacity is: <b>0.3</b></p>
            </div>
            <MapsList />
            <div className='form-group'>
              <Row>
                <Col md={12} xs={12}>
                  <div
                    onClick={this.props.initNewMap}
                    className='btn btn-primary btn-block'
                    >
                    <i className='fa fa-plus' />Add Map
                  </div>
                </Col>
              </Row>
              {current_map != null ? (
                <Row className='mt-md'>
                  <Col md={4} xs={4}>
                    <Button
                      block
                      onClick={() => this.props.updateDrawingMode(null)}
                      bsStyle={drawing_mode == null ? 'primary' : 'default'}
                      >
                      <i className='fa fa-hand-pointer-o' />
                    </Button>
                  </Col>
                  <Col md={4} xs={4}>
                    <Button
                      block
                      onClick={() => this.props.updateDrawingMode('Polygon')}
                      bsStyle={drawing_mode == 'Polygon' ? 'primary' : 'default'}
                      >
                      <i className='fa fa-pencil' />
                    </Button>
                  </Col>
                  <Col md={4} xs={4}>
                    <Button
                      block
                      onClick={() => this.props.updateDrawingMode('Point')}
                      bsStyle={drawing_mode == 'Point' ? 'primary' : 'default'}
                      >
                      <i className='fa fa-map-marker' />
                    </Button>
                  </Col>
                </Row>
              ) : null}
            </div>
            <hr className='separator' />
            {show_swath_editor ? <SwathEditor key='swatheditor'/> : null}
            {show_marker_creator ? <MarkerCreator key='markercreator'/> : null}
            {show_marker_editor ? <MarkerEditor key='markereditor'/> : null}
            </div>
          </div>
        </div>
      </menu>
    );
  }
}

export default mapCreatorConnect(MapCreatorSidebar);



// WEBPACK FOOTER //
// ./src/browser/components/map-creator/map-creator-sidebar.js